import React from 'react';
import BrandCard from './BrandCard';
import { brands } from '../../data/brands';

export default function BrandsList() {
  return (
    <section className="mobile-section bg-white">
      <div className="mobile-container">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            Brands We Service
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Expert repair services for all major appliance brands
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
          {brands.map((brand) => (
            <BrandCard key={brand.id} brand={brand} />
          ))}
        </div>
      </div>
    </section>
  );
}